(function () {

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem("wishlist")) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }

  function toggleWishlist(handle, btn) {
    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
      btn.innerText = "♡ Add to Wishlist";
    } else {
      wishlist.push(handle);
      btn.innerText = "✓ Added";
    }

    saveWishlist(wishlist);
    console.log("Wishlist:", wishlist); // DEBUG
  }

  function initWishlistButtons() {
    let buttons = document.querySelectorAll(".wishlist-btn");

    buttons.forEach(btn => {
      let handle = btn.dataset.handle;

      if (!handle) return;

      let wishlist = getWishlist();

      // Set initial state
      if (wishlist.includes(handle)) {
        btn.innerText = "✓ Added";
      }

      btn.addEventListener("click", function () {
        toggleWishlist(handle, btn);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initWishlistButtons);

})();